export default {
  "busyBackground": "_busyBackground_t8g0a_1",
  "loadingCircle": "_loadingCircle_t8g0a_10",
  "loadingFrames": "_loadingFrames_t8g0a_1",
  "loadingCircleContent": "_loadingCircleContent_t8g0a_22"
};import "ni:sha-256;nmmhSum5Cj2Z5uuTRQVRHgmDDD6gTt7I67Fh65v6GgY";